import {
    DefaultDataServiceConfig,
    EntityDispatcherDefaultOptions,
    EntityMetadataMap
} from '@ngrx/data';
import { patientMessageEntityMetadata, patientMessageHttpResourceUrls } from '../../message-list/state/message.entity';

import {
    adaptiveRuleEntityMetadata,
    adaptiveRuleHttpResourceUrls
} from '../../adaptive-rules/state/adaptive-rule.entity';
import { missedAppointmentsDashboardEntityMetadata } from '../../modules/dashboard/missed-appointments-widget/state/missed-appointments-dashboard.entity';
import { recallsDashboardEntityMetadata } from '../../modules/dashboard/recalls-widget/state/recalls-dashboard.entity';
import {
    previewEditTemplateEntityMetadata,
    previewEditTemplateHttpResourceUrls
} from '../../preview-edit-template/state/preview-edit-template.entity';
import { appointmentListEntityMetadata } from '../../reminders/appointment-list/state/appointment-list.entity';
import { remindersReportEntityMetadata } from '../../reminders/appointment-list/state/reminders-report.entity';
import {
    dateAppointmentEntityMetadata,
    dateAppointmentHttpResourceUrls
} from '../../reminders/appointments/state/date-appointment.entity';
import {
    patientAppointmentEntityMetadata,
    patientAppointmentHttpResourceUrls
} from '../../reminders/patients/state/patient-appointment.entity';
import { providerEntityMetadata, providerHttpResourceUrls } from '../../reminders/reminder-settings/state/provider.entity';
import {
    strategyEntityMetadata, strategyHttpResourceUrls
} from '../../reminders/reminder-settings/state/strategy.entity';

export const entityDataServiceConfig: DefaultDataServiceConfig = {
    root: 'servlets/',

    entityHttpResourceUrls: {
        Strategy: strategyHttpResourceUrls,
        Provider: providerHttpResourceUrls,
        PatientMessage: patientMessageHttpResourceUrls, // Not used
        DateAppointment: dateAppointmentHttpResourceUrls,
        PatientAppointment: patientAppointmentHttpResourceUrls,
        AdaptiveRule: adaptiveRuleHttpResourceUrls,
        PreviewEditTemplate: previewEditTemplateHttpResourceUrls
    }
};

export const entityMetadata: EntityMetadataMap = {
    Strategy: strategyEntityMetadata,
    Provider: providerEntityMetadata,
    PatientMessage: patientMessageEntityMetadata,
    DateAppointment: dateAppointmentEntityMetadata,
    PatientAppointment: patientAppointmentEntityMetadata,
    AppointmentList: appointmentListEntityMetadata,
    RemindersReport: remindersReportEntityMetadata,
    AdaptiveRule: adaptiveRuleEntityMetadata,
    PreviewEditTemplate: previewEditTemplateEntityMetadata,
    RecallsDashboard: recallsDashboardEntityMetadata,
    MissedAppointmentsDashboard: missedAppointmentsDashboardEntityMetadata
};

export const pluralNames = {
    Strategy: 'entities',
    Provider: 'entities',
    AdaptiveRule: 'entities',
    PreviewEditTemplate: 'entities'
};

export const entityConfig = {
    entityMetadata,
    pluralNames
};

export const entityDispatcherDefaultOptions: EntityDispatcherDefaultOptions = {
    optimisticAdd: false, // default false (if true then we need to provide valid ID which typically will be provided on saving)
    optimisticDelete: false,
    optimisticUpdate: true, // default false
    optimisticUpsert: false,
    optimisticSaveEntities: false
};
